var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.46568 4.59396C6.46229 4.59396 4.02755 7.02869 4.02755 10.0321C4.02755 13.0355 6.46229 15.4702 9.46568 15.4702C12.4691 15.4702 14.9038 13.0355 14.9038 10.0321C14.9038 7.02869 12.4691 4.59396 9.46568 4.59396ZM2.21484 10.0321C2.21484 6.02756 5.46115 2.78125 9.46568 2.78125C13.4702 2.78125 16.7165 6.02756 16.7165 10.0321C16.7165 14.0366 13.4702 17.2829 9.46568 17.2829C5.46115 17.2829 2.21484 14.0366 2.21484 10.0321Z",
    fill: "#727E8D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3566 13.923C13.7105 13.569 14.2844 13.569 14.6383 13.923L20.0765 19.3611C20.4304 19.715 20.4304 20.2889 20.0765 20.6429C19.7225 20.9968 19.1486 20.9968 18.7947 20.6429L13.3566 15.2047C13.0026 14.8508 13.0026 14.2769 13.3566 13.923Z",
    fill: "#727E8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIco);
export default __webpack_public_path__ + "static/media/search_ico.1f858a0f814764c2ec9fa6ed1f291779.svg";
export { ForwardRef as ReactComponent };